import { formatPrice } from '@payaca/helpers/financeHelper';
import { CurrencyValue as TCurrencyValue } from '@payaca/types/currencyTypes';

const f = formatPrice(navigator.language);

const usePreferredCurrencyFormat = (args: TCurrencyValue) => {
  const { value, currency } = args;

  return f({
    priceInMinorCurrencyUnits: value,
    exponent: currency.exponent,
    currencyCode: currency.code,
  });
};

export default usePreferredCurrencyFormat;
